import React from 'react';
import { useAppSelector } from '../../hooks';

interface Props {
  startDate: string;
  endDate: string;
  orgId: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onOrgIdChange: (orgId: string) => void;
}

const DashboardFilters: React.FC<Props> = ({
  startDate,
  endDate,
  orgId,
  onStartDateChange,
  onEndDateChange,
  onOrgIdChange,
}) => {
  const { user } = useAppSelector((state) => state.auth);
  const isSuperAdmin = user?.role === 'super_admin';

  return (
    <div className="flex flex-wrap gap-4 items-center mb-6">
      <div className="flex items-center gap-2">
        <label htmlFor="start-date" className="text-sm text-gray-600 dark:text-gray-400">
          From
        </label>
        <input
          type="date"
          id="start-date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          className="rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>

      <div className="flex items-center gap-2">
        <label htmlFor="end-date" className="text-sm text-gray-600 dark:text-gray-400">
          To
        </label>
        <input
          type="date"
          id="end-date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          className="rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>

      {isSuperAdmin && (
        <div className="flex items-center gap-2">
          <label htmlFor="org-id" className="text-sm text-gray-600 dark:text-gray-400">
            Organization ID
          </label>
          <input
            type="text"
            id="org-id"
            value={orgId}
            onChange={(e) => onOrgIdChange(e.target.value)}
            placeholder="Filter by org ID"
            className="rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
      )}
    </div>
  );
};

export default DashboardFilters;
